import script from "./SyncSettingsModalRemoveProject.vue?vue&type=script&setup=true&lang=js"
export * from "./SyncSettingsModalRemoveProject.vue?vue&type=script&setup=true&lang=js"

import "./SyncSettingsModalRemoveProject.vue?vue&type=style&index=0&id=d6cd199c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6cd199c"]])

export default __exports__